import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

Vue.use(Vuex);


const state={
    bgActive:[]
}



export default  new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js